import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import {
  MonthlySnapshot,
  CreateSnapshotRequest,
  UpdateSnapshotRequest,
  PagedRequest,
  PagedResponse,
} from '@core/models';

@Injectable({ providedIn: 'root' })
export class SnapshotService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.snapshots}`;

  getAll(): Observable<MonthlySnapshot[]> {
    return this.http.get<MonthlySnapshot[]>(this.baseUrl);
  }

  getById(id: string): Observable<MonthlySnapshot> {
    return this.http.get<MonthlySnapshot>(`${this.baseUrl}/${id}`);
  }

  getPaged(request: PagedRequest): Observable<PagedResponse<MonthlySnapshot>> {
    return this.http.post<PagedResponse<MonthlySnapshot>>(
      `${this.baseUrl}/paged`,
      request
    );
  }

  create(snapshot: CreateSnapshotRequest): Observable<MonthlySnapshot> {
    return this.http.post<MonthlySnapshot>(this.baseUrl, snapshot);
  }

  update(snapshot: UpdateSnapshotRequest): Observable<MonthlySnapshot> {
    return this.http.put<MonthlySnapshot>(this.baseUrl, snapshot);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
